/*
 * WARNING: This file is PUBLIC!
 * Do NOT hardcode, or import anything that could compromise security
*/

/* eslint-disable no-process-env, no-undef */
const {
  NODE_ENV = 'production',
} = process.env;
/* eslint-enable no-process-env, no-undef */

export default {
  env: NODE_ENV,
  browser: (typeof document !== 'undefined') && (typeof window !== 'undefined'),
};



// WEBPACK FOOTER //
// ./src/config.js